module.exports = __webpack_public_path__ + "static/chatter-mockup-c069e3bd0feb5d6fdfa55fabd3ddaff9.png";